import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import axios, { endPoints } from 'api/request';
import { useMutation } from 'react-query';
import { LDAP_GROUP } from 'pages/myidm/utils/constant';
import Select from 'pages/reference-implementation/components/select';
import { OrderPayload } from 'pages/myidm/store';

export const ApplicationService = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [options, setOptions] = React.useState([]);

    const validateApi = useMutation((payload) => axios.post(endPoints?.ssp?.kafka?.ldapGroup, payload));

    const setApplicationService = (appService) => {
        setOrder({ ...order, appService, applicationName: null, appShortName: null });
    };

    const resetOptions = () => {
        setOptions([]);
    };

    const isExistsInOptions = (dataClassifiation) => options.find((option) => dataClassifiation === option.value);

    const handleOnSelectChange = (selected) => setApplicationService(selected.value);

    React.useEffect(() => {
        if (options && options?.length === 1 && !order?.appService) {
            setOrder({ ...order, appService: options?.[0].value });
        }
        if (options && options?.length && order?.appService) {
            const appService = isExistsInOptions(order?.appService);
            setOrder({ ...order, appService: appService?.value });
        }
    }, [options]);

    // application services derived from the businessCi details fetched by BusinessApp, no separate api call
    React.useEffect(() => {
        resetOptions();
        if (order?.businessAppDetails && order?.businessAppDetails?.applicationServices) {
            setOptions(order?.businessAppDetails?.applicationServices?.map((app) => ({ label: app?.serviceName, value: app?.serviceName })));
        }
    }, [order?.businessAppDetails]);

    React.useEffect(() => {
        if (order?.groupType === LDAP_GROUP && order?.appService && order?.environment) {
            validateApi.mutate({
                applicationName: order?.appService,
                environment: order?.environment,
            });
        }
    }, [order?.appService, order?.environment, order?.groupType]);

    React.useEffect(() => {
        if (!order?.appService && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.appService, order?.isTouched]);
    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Select
                key="ApplicationService"
                label="Application Service *"
                value={order?.appService || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                disabled={!order?.businessAppDetails}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(ApplicationService);
